var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mx-md-2 px-md-2 mx-sm-1 px-sm-1",attrs:{"no-gutters":""}},[_c('div',{staticClass:"text-center flex justify-center align-center text-xl font-Handel h-[calc(100vh-150px)] bg-black rounded-3xl animate-pulse"},[_c('div',[_vm._v(" No "+_vm._s(_vm.type)+" selected ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }